/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {SpacierArcadeGameConfig} from "./SpacierArcadeGameConfig";

export class SpacierArcadeGameAssets {
    public static SYMBOL_STATES:string = "symbol_states";
    public static SYMBOL_STATES_FS:string = "symbol_states_fs";
    public static WILD_SYMBOL:string = "wild";
    public static WILD_SYMBOL_FS:string = "wild_fs";
    public static SCATTER:string = "scatter";
    public static BACKGROUND:string = "bg";
    public static FG_EFFECTS:string = "fg_effects";
    public static FG_IDLE:string = "foreground_idle";
    public static BIG_WIN:string = "big_win";
    public static BIG_WIN_SHINE:string = "big_win_shine";
    public static S_ANTICIPATION:string = "scatter_anticipation";
    public static W_ANTICIPATION:string = "wild_anticipation";
    public static W_ANTICIPATION_FS:string = "wild_anticipation_fs";
    public static INTRO_BACKGROUND: string = "resources/images/intro/introBackground.jpg";
    public static INTRO_LOGO: string = "introLogo";
    public static INTRO_FEATURE_1:string = "resources/images/intro/sticky_respin.png";
    public static INTRO_FEATURE_2:string = "resources/images/intro/milky_ways_feature.png";
    public static LOGO_LANDSCAPE:string = "resources/images/intro/mw_logo_landscape.png";
    public static INTRO_BUY_FEATURE_ICON =  "resources/images/intro/buyFeatureIcon.svg";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";
    public static FREESPIN_BACKGROUND: string = "mainBackground";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return [PIXI.Texture.EMPTY];
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("mw_font", "fonts/bitmapfonts/mw_font.fnt")
                ]
            },
            {
                name: "intro",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations: {
                    "introLogo": "introLogo",
                    "introDivider" : "Intro_Divider"
                }
            },
            {
                name: "introJpeg",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ],
                animations: {
                    "introBackground": "introBackground"
                }
            },
            {
                name : "introFw",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introFw", "sheets/introFw/introFw0.json")
                ],
                animations : {
                    "introArrowLeft" : "ArrowLeft",
                    "introArrowRight" : "ArrowRight",
                    "introXNudge" : "X_Nudge",
                    "introDotActive" : "Dot_Selected",
                    "introDotInactive" : "Dot"
                }
            }
        ],
        main : [
            {
                name : "spine",
                assets : [
                    new SpineAsset(SpacierArcadeGameAssets.SYMBOL_STATES, "sheets/spine/symbol_states_main.json"),
                    new SpineAsset(SpacierArcadeGameAssets.SYMBOL_STATES_FS, "sheets/spine/symbol_states_fs.json"),
                    new SpineAsset(SpacierArcadeGameAssets.WILD_SYMBOL, "sheets/spine/wild.json"),
                    new SpineAsset(SpacierArcadeGameAssets.WILD_SYMBOL_FS, "sheets/spine/wild_5x5.json"),
                    new SpineAsset(SpacierArcadeGameAssets.SCATTER, "sheets/spine/scatter.json"),
                    new SpineAsset(SpacierArcadeGameAssets.BACKGROUND, "sheets/spine/bg.json"),
                    new SpineAsset(SpacierArcadeGameAssets.FG_EFFECTS, "sheets/spine/fg_effects.json"),
                    new SpineAsset(SpacierArcadeGameAssets.FG_IDLE, "sheets/spine/foreground_idle.json"),
                    new SpineAsset(SpacierArcadeGameAssets.BIG_WIN, "sheets/spine/big_win.json"),
                    new SpineAsset(SpacierArcadeGameAssets.BIG_WIN_SHINE, "sheets/spine/big_win_shine.json"),
                    new SpineAsset(SpacierArcadeGameAssets.S_ANTICIPATION, "sheets/spine/scatter_anticipation.json"),
                    new SpineAsset(SpacierArcadeGameAssets.W_ANTICIPATION, "sheets/spine/wild_anticipation.json"),
                    new SpineAsset(SpacierArcadeGameAssets.W_ANTICIPATION_FS, "sheets/spine/wild_anticipation_fs.json")
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),

                ],
                animations: {
                    "reelDivider": "ui/reelDividers/div",
                    "reelDividerNearWin": "ui/reelDividers/div-attention",
                    "button": "ui/gameTweakerButton/button",
                    "button-disabled": "ui/gameTweakerButton/button-disabled",
                    "snowFlake": "snowflake1",
                    "x2": "x2",
                    "x3": "x3",
                    "x4": "x4",
                    "trail": "test_trail",
                    "fs_intro_info": "fs/fs_intro_info",
                    "bigWinCoin" : "coins/coins_",
                    "fs_anti" : "fs/anticipation/vingette",
                    "countupBg" : "dark_oval",
                    "FS+1" : "freespinretrigger/+1FS",
                    "FS+2" : "freespinretrigger/+2FS",
                    "fs_intro_blackhole": "fs_intro_blackhole/fs_intro_blackhole",
                    "big_win": "big win names/big_win",
                    "big_bang": "big win names/big_bang",
                    "massive_win": "big win names/massive_win"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),

                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "winamount_flair": "effects/multi use/flairs/winamount_flair",
                    "reelAttention" : "reel_anticipation",
                    "fs_reel_blue" : "fs_intro/5_5_reel"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    
                ]
            }
        ]
    };
}
